import React, { useEffect, useState } from "react";
import "./terms.css";
import axios from "axios";

const TermsAndConditions = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const res = await axios.get(
          "https://fom.softsprint.ae/backendTest/info/terms-and-conditions",
        );
        setData(res.data.data);
      } catch (err) {
        setError("Failed to load terms and conditions");
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, []);

  if (loading) return <div className="terms-status">Loading...</div>;
  if (error) return <div className="terms-status error">{error}</div>;

  return (
    <div className="terms-container">
      <div className="terms-card">
        <h1 className="terms-title">{data.title}</h1>

        <div className="terms-meta">
          <span>
            <strong>Platform:</strong> {data.platform_name}
          </span>
          <span>
            <strong>Company:</strong> {data.company_name}
          </span>
          <span>
            <strong>Effective:</strong> {data.effective_date}
          </span>
          <span>
            <strong>Last Updated:</strong> {data.last_updated}
          </span>
          <span>
            <strong>Version:</strong> {data.version}
          </span>
        </div>

        <div className="terms-sections">
          {data.sections.map((section, index) => (
            <div key={index} className="terms-section">
              <h3>{section.title}</h3>
              <p>{section.content}</p>
            </div>
          ))}
        </div>

        <div className="terms-footer">
          <p>
            Contact:{" "}
            <a href={`mailto:${data.contact_email}`}>{data.contact_email}</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
